import Vue from 'vue';
import VueSignature from "vue-signature-pad";

Vue.use(VueSignature);